import React from 'react';
import { useSelector } from '@shared/store';
import { MBChatAttachmentComponent, MBChatAttachmentProps } from '../components/attachment';

type OwnProps = Omit<MBChatAttachmentProps, 'progress'>;

export function MBChatAttachment(props: OwnProps) {
  const { attachment } = props;
  const fileUploadProgressById = useSelector(state => state.upload.fileUploadProgressById);
  const progress = fileUploadProgressById[attachment.fileKey];

  return <MBChatAttachmentComponent {...props} progress={progress} />;
}
